import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container-footer">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-col footer-col-logo">
              <div className="footer-logo-wrapper">
                <img
                  src="/images/LOGO_WITH_NAME.png"
                  alt="Tirupati Enterprises"
                  className="footer-logo-img"
                />
              </div>
              <p className="footer-desc">
                Tirupati Enterprises deals in Packing Machines &amp; Packing Materials. We aim to provide the best packaging solutions to meet your needs.
              </p>
              {/* Vendor Logos */}
              <div className="vendor-logos">
                <div className="vendor-logo-item">
                  <img
                    src="/images/signode.png"
                    alt="Signode"
                  />
                </div>
                <div className="vendor-logo-item">
                  <img
                    src="/images/zavenir-daubert.png"
                    alt="Zavenir Daubert"
                  />
                </div>
              </div>
              <div className="vendor-logos vendor-logos-row2">
                <div className="vendor-logo-item">
                  <img
                    src="/images/storo.jpg"
                    alt="Storopack"
                  />
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h3 className="footer-title">Quick Link</h3>
              <ul className="footer-links">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Follow Us */}
            <div className="footer-col">
              {/* <h3 className="footer-title">Follow Us</h3>
              <ul className="footer-links footer-social-links">
                {socialLinks.map((social) => (
                  <li key={social.name}>
                    <a href={social.url} target="_blank" rel="noopener noreferrer">
                      {social.name}
                    </a>
                  </li>
                ))}
              </ul> */}
              
              {/* Grab Our Flyer */}
              <div className="footer-flyer">
                <h4 className="footer-flyer-title">Grab Our Flyer!</h4>
                <a href="/flyer.pdf" className="btn-download" download>
                  Download
                </a>
              </div>
            </div>

            {/* Contact Info */}
            <div className="footer-col">
              <h3 className="footer-title">Contact Us</h3>
              <div className="footer-contact-info">
                <p className="footer-contact-item">
                  <strong>Address:</strong> 205, Anmol Sagar Darshan, 9/1, New Palasia, Indore (M.P.)
                </p>
                <p className="footer-contact-item">
                  <strong>Phone:</strong> <a href="tel:+919301305107">93013-05107</a>, <a href="tel:+919826144402">98261-44402</a>
                </p>
                <p className="footer-contact-item">
                  <strong>Mail Id:</strong> <a href="mailto:tp_ent@rediffmail.com">tp_ent@rediffmail.com</a>, <a href="mailto:singhdinesh1001@gmail.com">singhdinesh1001@gmail.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container-footer">
          <p className="footer-copyright">Copyright © {new Date().getFullYear()} Tirupati Enterprises</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;